import axios from "axios";

export interface ISaveExpenditureDetailsOnFullAppFormEvent {
    transaction: {
        id: string;
    };
    formData: {
        netIncome: string;
        additionalNetIncome?: string;
        livingConditions: string;
        selfUsedProperty?: string;
        monthlyRateLease?: string;
        monthlyRateProperty?: string;
        extraCost: string;
        alimentChildrenCount: string;
        creditsAndLoans: string;
        monthlyCreditRate?: string;
        isMajorityShareholder: string;
        majorityShareholderCompanyName?: string;
        majorityShareholderCompanyCity?: string;
        isLiablePartner: string;
        liablePartnerCompanyName?: string;
        liablePartnerCompanyCity?: string;
    };
}

export const saveExpenditureDetails = async (transactionId: string, formValues:
    {
        netIncome: string;
        additionalNetIncome: string;
        livingConditions: string;
        selfUsedProperty: string;
        monthlyRateLease: string;
        monthlyRateProperty: string;
        extraCost: string;
        alimentChildrenCount: string;
        creditsAndLoans: string;
        monthlyCreditRate: string;
        isMajorityShareholder: string;
        majorityShareholderCompanyName: string;
        majorityShareholderCompanyCity: string;
        isLiablePartner: string;
        liablePartnerCompanyName: string;
        liablePartnerCompanyCity: string;
    }) => {

    const body: ISaveExpenditureDetailsOnFullAppFormEvent = {
        transaction: {
            id: transactionId,
        }, formData: {
            netIncome: formValues.netIncome,
            additionalNetIncome: formValues.additionalNetIncome,
            livingConditions: formValues.livingConditions,
            selfUsedProperty: formValues.selfUsedProperty,
            monthlyRateLease: formValues.monthlyRateLease,
            monthlyRateProperty: formValues.monthlyRateProperty,
            extraCost: formValues.extraCost,
            alimentChildrenCount: formValues.alimentChildrenCount,
            creditsAndLoans: formValues.creditsAndLoans,
            monthlyCreditRate: formValues.monthlyCreditRate,
            isMajorityShareholder: formValues.isMajorityShareholder,
            majorityShareholderCompanyName: formValues.majorityShareholderCompanyName,
            majorityShareholderCompanyCity: formValues.majorityShareholderCompanyCity,
            isLiablePartner: formValues.isLiablePartner,
            liablePartnerCompanyName: formValues.liablePartnerCompanyName,
            liablePartnerCompanyCity: formValues.liablePartnerCompanyCity,
        }
    };

    return axios.post(process.env.REACT_APP_SAVE_EXPENDITURE_DETAILS_FULL_APP_FORM_URL, body);
};
